/**
 * Login page i18n strings — EN and AR.
 * Exact text from the design preview. Keep keys stable; copy editors edit values.
 */

export type Locale = 'en' | 'ar';

export type LoginStrings = {
  // shared
  email: string;
  workEmail: string;
  emailPlaceA: string;
  emailPlaceB: string;
  password: string;
  pwPlaceA: string;
  pwPlaceB: string;
  forgot: string;
  reset: string;
  signIn: string;
  continue: string;
  needAccess: string;
  contactAdmin: string;
  requestAdmin: string;
  keepSigned: string;
  session: string;

  // A — Quiet Authority
  eyebrowA: string;
  welcomeA: [string, string, string];
  subA: string;

  // B — Charter / Editorial
  eyebrowB: string;
  titleB: string;
  subB: string;
  asideLabel: string;
  pull1: string;
  pull2: string;
  pullAttr: string;
  stat1: string;
  stat2: string;
  stat3: string;

  // bottom row
  bottomCity: string;
  bottomCert: string;
  dataResidency: string;
};

export const LOGIN_I18N: Record<Locale, LoginStrings> = {
  en: {
    email: 'Email',
    workEmail: 'Work email',
    emailPlaceA: 'you@firm.com',
    emailPlaceB: 'counsel@firm.com',
    password: 'Password',
    pwPlaceA: '••••••••••',
    pwPlaceB: 'Enter password',
    forgot: 'Forgot',
    reset: 'Reset',
    signIn: 'Sign in',
    continue: 'Continue',
    needAccess: 'Need access?',
    contactAdmin: 'Contact your administrator',
    requestAdmin: 'Request from administrator →',
    keepSigned: 'Keep me signed in',
    session: 'Session 12h',

    eyebrowA: 'Sign in · v1.0',
    welcomeA: ['Welcome to ', 'BassitAI', '.'],
    subA: 'The intelligence partner for legal, financial, and regulatory work across the GCC.',

    eyebrowB: 'Step 01 / Authenticate',
    titleB: 'Sign in.',
    subB: 'One account for tenants, operators, and platform administrators.',
    asideLabel: '— A platform note',
    pull1: 'Regional law moves at the speed of regulation.',
    pull2: "Your practice shouldn't.",
    pullAttr:
      'BassitAI indexes legislation, rulings, and contracts across Kuwait, the UAE, KSA, Bahrain, Qatar, and Oman — and reads them the way you would.',
    stat1: 'Jurisdictions',
    stat2: 'Indexed pages',
    stat3: 'Bilingual',

    bottomCity: 'Kuwait City · Riyadh · Dubai',
    bottomCert: 'SOC 2 · ISO 27001',
    dataResidency: 'SOC 2 · ISO 27001 · Data residency: GCC',
  },
  ar: {
    email: 'البريد الإلكتروني',
    workEmail: 'البريد الإلكتروني للعمل',
    emailPlaceA: 'you@firm.com',
    emailPlaceB: 'counsel@firm.com',
    password: 'كلمة المرور',
    pwPlaceA: '••••••••••',
    pwPlaceB: 'أدخل كلمة المرور',
    forgot: 'نسيت؟',
    reset: 'إعادة تعيين',
    signIn: 'تسجيل الدخول',
    continue: 'متابعة',
    needAccess: 'تحتاج صلاحية؟',
    contactAdmin: 'تواصل مع المسؤول',
    requestAdmin: 'تقديم طلب للمسؤول ←',
    keepSigned: 'تذكرني',
    session: 'الجلسة 12 ساعة',

    eyebrowA: 'تسجيل الدخول · الإصدار 1.0',
    welcomeA: ['أهلاً بك في ', 'BassitAI', '.'],
    subA: 'شريك الذكاء الاصطناعي للأعمال القانونية والمالية والتنظيمية في دول الخليج.',

    eyebrowB: 'الخطوة 01 / تحقق',
    titleB: 'تسجيل الدخول.',
    subB: 'حساب واحد للمستأجرين والمشغلين ومسؤولي المنصة.',
    asideLabel: '— ملاحظة من المنصة',
    pull1: 'القانون الإقليمي يتغير بسرعة التشريع.',
    pull2: 'ممارستك لا ينبغي أن تتأخر.',
    pullAttr:
      'BassitAI يفهرس التشريعات والأحكام والعقود في الكويت والإمارات والسعودية والبحرين وقطر وعُمان — ويقرأها بالطريقة التي تقرأها بها.',
    stat1: 'اختصاصات قضائية',
    stat2: 'صفحات مفهرسة',
    stat3: 'ثنائية اللغة',

    bottomCity: 'مدينة الكويت · الرياض · دبي',
    bottomCert: 'SOC 2 · ISO 27001',
    dataResidency: 'SOC 2 · ISO 27001 · إقامة البيانات: الخليج',
  },
};
